const TERMINAL_DEVICE_LINK_GRANT_STATUSES = new Set(["expired", "canceled", "cancelled", "consumed"]);

function toFiniteNumber(value) {
  const numericValue = Number(value);
  return Number.isFinite(numericValue) ? numericValue : null;
}

export function isDeviceLinkGrantExpired(grant, nowSeconds = Math.floor(Date.now() / 1000)) {
  const expiresAtSeconds = toFiniteNumber(grant?.expires_at);
  return expiresAtSeconds !== null && expiresAtSeconds <= nowSeconds;
}

export function isDeviceLinkGrantInactive(grant, nowSeconds = Math.floor(Date.now() / 1000)) {
  if (TERMINAL_DEVICE_LINK_GRANT_STATUSES.has(String(grant?.status || "").toLowerCase())) {
    return true;
  }

  return isDeviceLinkGrantExpired(grant, nowSeconds);
}
